import { Injectable } from '@angular/core';

const USER_KEY = 'auth-user',
  WATCHED_POPUP = 'watched-popup';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  clean(): void {
    window.sessionStorage.removeItem(USER_KEY);
  }

  public saveUser(user: any): void {
    console.log('saving user key')
    try {
      window.sessionStorage.removeItem(USER_KEY);
      window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
      console.log('user key saved')
    } catch (error) {
      console.error('user key not saved', error)
    }
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      const userJson = JSON.parse(user);

      userJson.moderator = (userJson?.roles?.includes('ROLE_MODERATOR') || userJson?.roles?.includes('ROLE_ADMIN'))??false
      const jwtTokenExpires = JSON.parse(window.atob(userJson.token.split('.')[1])).exp;
      userJson.expires = new Date(jwtTokenExpires * 1000);

      return userJson;
    }

    return {};
  }

  public isLoggedIn(): boolean {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return true;
    }

    return false;
  }
  public hasWatchedPopup(version:string): boolean {
    const watchedPop = window.sessionStorage.getItem(WATCHED_POPUP+version)
    if (watchedPop) {
      return true
    }

    return false
  }
  setHaveWatchedPopup(version:string) {
    window.sessionStorage.removeItem(WATCHED_POPUP+version);
    window.sessionStorage.setItem(WATCHED_POPUP+version, "pop-up");
  }
}